import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

const CookieNotification = () => {
    const { t } = useTranslation();
    const [isVisible, setIsVisible] = useState(false);

    useEffect(() => {
        // Показываем плашку только если юзер еще не принял условия
        if (localStorage.getItem('acceptCookie') !== 'accepted') {
            setIsVisible(true);
        }
    }, []);

    const acceptCookie = () => {
        localStorage.setItem('acceptCookie', 'accepted');
        setIsVisible(false);
    };

    if (!isVisible) return null;

    return (
        <div className="cookie-notification">
            <div className="cookie-notification__modal">
                <div className="cookie-notification__icon"></div>

                <div className="cookie-notification__content">
                    <h2 className="cookie-notification__title">
                        {t('translate.cookie_title') || 'Cookie Policy'}
                    </h2>

                    <div className="cookie-notification__body">
                        <p className="cookie-notification__text">
                            {t('translate.cookie_subtitle')} {' '}
                            <a
                                href="https://chernykh.tech/privacy-policy"
                                className="cookie-notification__link"
                                target="_blank"
                                rel="noreferrer"
                            >
                                {t('translate.cookie_privacy')}
                            </a>
                        </p>

                        <button
                            className="cookie-notification__button"
                            onClick={acceptCookie}
                        >
                            {t('translate.cookie_btn1') || 'Accept'}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CookieNotification;